import { useMemo } from 'react';
import equal from 'fast-deep-equal';

import { ColorOptionIcon } from './ColorOptionIcon';

export function ColorOptionButton({
  inventory,
  isLoading,
  isSelected,
  newSelectedOptions,
  product,
  setSelectedOptions,
  swatch,
  value,
  enabledSoldOutColorSwatch,
  isSoldOut,
}) {
  const variantFromOptionValue = useMemo(() => {
    if (!newSelectedOptions) return null;
    return product.variants?.find(({ selectedOptionsMap }) => {
      return equal(newSelectedOptions, selectedOptionsMap);
    });
  }, [newSelectedOptions, product.variants]);

  const optionValueIsAvailable =
    inventory?.variants?.[variantFromOptionValue?.id]?.availableForSale ||
    false;
  const disabled = isLoading || !variantFromOptionValue;
  const isUnavailable = isSoldOut ? true : (!optionValueIsAvailable && !disabled);

  return (
    <button
      aria-label={`${value}${isUnavailable ? ' is Sold Out' : ''}`}
      className="group/color"
      disabled={disabled}
      onClick={() => {
        if (isSelected) return;
        setSelectedOptions(newSelectedOptions);
      }}
      type="button"
    >
      <ColorOptionIcon
        disabled={disabled}
        isUnavailable={isUnavailable}
        isSelected={isSelected}
        swatch={swatch}
        value={value}
        enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
        isAllOutOfStock={isSoldOut}
      />
    </button>
  );
}

ColorOptionButton.displayName = 'ColorOptionButton';
